import { createFileRoute } from '@tanstack/react-router'

import { SectionLabel } from '@/components/shared'
import { PlanCard } from '@/components/spravce/plany'
import { NEEDS_YOU, RUNNING_FINE } from '@/mocks/spravce/plany'

export const Route = createFileRoute('/spravce/plany')({
  head: () => ({ meta: [{ title: 'Plány · Aplikace Bitez' }] }),
  component: SpravcePlany,
})

function SpravcePlany() {
  return (
    <div className="px-4 pt-6 pb-6">
      <section className="animate-rise-up">
        <SectionLabel>Potřebuje vás</SectionLabel>
        <div className="mt-3 space-y-3">
          {NEEDS_YOU.map((plan) => (
            <PlanCard key={plan.venue} plan={plan} />
          ))}
        </div>
      </section>

      <section className="animate-rise-up mt-7" style={{ animationDelay: '90ms' }}>
        <p className="text-[10px] font-bold tracking-widest text-ink/40 uppercase">Běží samo</p>
        <div className="mt-3 space-y-3">
          {RUNNING_FINE.map((plan) => (
            <PlanCard key={plan.venue} plan={plan} />
          ))}
        </div>
      </section>
    </div>
  )
}
